

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form3";
const form3State = namespace("Form3");

import { form3DataInfoType, form3SearchInfoType } from '@/types/Information/Form3';
import { initiatingDocumentJsonInfoType, partiesDataJsonDataType, previousCourtJsonInfoType } from '@/types/Information/json';
import Spinner from "@/components/utils/Spinner.vue";

@Component({
    components: {           
        Spinner
    }        
}) 
export default class Form3CaseInformation extends Vue {

    @informationState.Action
    public UpdatePartiesJson!: (newPartiesJson: partiesDataJsonDataType) => void

    @informationState.Action
    public UpdatePreviousCourts!: (newPreviousCourts: previousCourtJsonInfoType[]) => void

    @informationState.Action
    public UpdateInitiatingDocuments!: (newInitiatingDocuments: initiatingDocumentJsonInfoType[]) => void

    @informationState.Action
    public UpdateFileNumber!: (newFileNumber: string) => void
    
    @form3State.Action
    public UpdateCurrentNoticeOfCrossAppealId!: (newCurrentNoticeOfCrossAppealId: string) => void
    
    @form3State.Action
    public UpdateForm3Info!: (newForm3Info: form3DataInfoType) => void

    @form3State.State
    public form3Info: form3DataInfoType;
    
    levelOfCourt = "Court of Appeal";

    fileNumberState = null;
    partyState = true;
    dataReady = false;
    searching = false;

    searchParams = {} as form3SearchInfoType;
    notFound = false;
    partyOptions = [
        {text: 'Individual', value: 'Individual'},
        {text: 'Organization', value: 'Organization'}
    ];

    mounted(){
        this.fileNumberState = null;
        this.partyState = null;
        this.dataReady = false;
        this.searching = false;
        this.dataReady = true; 
    }

    public navigateToForm3() {

        const form3SubmissionData = this.form3Info;
        form3SubmissionData.manualAppellants = [];
        form3SubmissionData.manualRespondents = [];
        form3SubmissionData.appellants = [];
        form3SubmissionData.manualRespondents = [];
        form3SubmissionData.requiresManualEntry = true;       
        this.UpdateForm3Info(form3SubmissionData);
        this.UpdateCurrentNoticeOfCrossAppealId(null);
        this.$router.push({name: "fill-form3"})
    }

    public findFile(){

        this.searching = true;        
        this.notFound = false;
        this.fileNumberState = null;
        this.partyState = null;

        if(!this.searchParams.file){
            this.fileNumberState = false;
            this.searching = false;
            return
        }

        if(!this.searchParams.searchBy){
            this.partyState = false;
            this.searching = false;
            return
        }
        
        const url = '/form7s/?'+
            'caseNumber='+(this.searchParams.file?this.searchParams.file:'')+
            '&firstName='+(this.searchParams.firstName?this.searchParams.firstName:'')+
            '&lastName='+(this.searchParams.lastName?this.searchParams.lastName:'')+
            '&searchBy='+(this.searchParams.searchBy?this.searchParams.searchBy:'')+
            '&organizationName='+(this.searchParams.organizationName?this.searchParams.organizationName:''); 
        
        this.$http.get(url)
        .then(res => {
            this.searching = false;
            
            if(res.data?.previousCourts){
                this.UpdatePreviousCourts(res.data?.previousCourts)
            }

            if(res.data?.initiatingDocuments?.InitiatingDocument){
                this.UpdateInitiatingDocuments(res.data?.initiatingDocuments?.InitiatingDocument)
            }
            
            if(res.data?.parties){
                this.UpdatePartiesJson(res.data.parties);
                this.UpdateFileNumber(this.searchParams.file)
                this.UpdateCurrentNoticeOfCrossAppealId(null);

                const form3SubmissionData = this.form3Info;
                form3SubmissionData.requiresManualEntry = false;       
                this.UpdateForm3Info(form3SubmissionData);

                this.$router.push({name: "fill-form3"})
            }

            if (!res.data){
                this.notFound = true;
            }
                
        },err => {
            console.error(err); 
            this.notFound = true;  
            this.searching = false;     
        });
    }

    public coaFileformatter(value){
        if(value.slice(0,2)!='CA'){
            if(isNaN(Number(value.slice(0))))
                return 'CA'
            else
                return 'CA'+value
        }
        if(isNaN(Number(value.slice(-1)))) return value.slice(0,-1)
        return value
    }
}
